import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { changes } from "src/components/utils/fields";
import { useMediaQuery } from "@mui/material";
import {
  BufferService,
  LoadingContext,
  NavigateContext,
  M_Button,
  M_Fieldset,
  M_Header,
  M_MessageBoard,
} from "src/M_Components";
import { Refresh } from "@mui/icons-material";
import { QuoteInfo } from "./components/QuoteInfo";
import { QuoteDates } from "./components/QuoteDates";
import { QuotePorts } from "./components/QuotePorts";
import { QuoteEntities } from "./components/QuoteEntities";
import { QuoteEquipment } from "./components/QuoteEquiment";
import { QuoteGoods } from "./components/QuoteGoods";
import { QuoteCalculator } from "./components/QuoteCalculator";
import { QuoteCharges } from "./components/QuoteCharges";
import { QuoteFormField } from "./components/QuoteFormField";
import { hasGoodsDescription, hasValue, buildQuotePayload, getCompanyOptionsFromSession, hydrateGoodsFromQuoteDescription, normalizeQuoteEquipmentsForSave, normalizeQuoteGoodsForSave, resolveCompanyState, resolveQuoteGoodsDescription } from "./utils/quoteValidation";
import { parseSessionStorageItem } from "./utils/quoteSessionStorage";
import {
  QuoteEquipmentGoodsSection,
  QuoteInfoDatesPortsSection,
} from "./components/QuotePageSections";

export const ApproveQuoteDetail = ({ roles }) => {
  const [id, setId] = useState(sessionStorage.getItem("selectedTab"));
  const { t } = useTranslation();
  const ctx = useContext(LoadingContext);
  const navigateCtx = useContext(NavigateContext)
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [passedRow, setPassedRow] = useState({});
  const [operation, setOperation] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [triggerAddNewCharge, setTriggerAddNewCharge] = useState(false);

  const [showRejectDialog, setShowRejectDialog] = useState(false)

  const accountService = new BufferService("Account");
  const quoteService = new BufferService("Quote");
  const quoteGetRequestService = new BufferService("quotegetrequest");
  const quoteCreateRequestService = new BufferService("quotecreaterequest");
  const quoteUpdateRequestService = new BufferService("quoteupdaterequest");

  const sessionKeys = ["operation", "data", "open", "passedRow"];

  const matches11 = useMediaQuery("(min-width:970px)");
  const matches12 = useMediaQuery("(min-width:930px)");
  const matches16 = useMediaQuery("(min-width:440px)");

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true);
      getSessionStorageData(id);
      setIsFirstTime(false);
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
    }
  }, []);

  useEffect(() => {
    const passOperation = ctx.passValue.get("operation");
    setOperation(passOperation);
  }, []);

  useEffect(() => {
    const newId = sessionStorage.getItem("selectedTab");
    if (newId !== id) {
      setId(newId);
      getSessionStorageData(newId);
    }
  }, []);

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key);
    });
    // eslint-disable-next-line
  }, [id, operation, data]);

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
      return;
    if (eval(value) instanceof String && eval(value) === "") return;
    if (eval(value) instanceof Number && eval(value) === "") return;

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(
        `${id}${key}`,
        JSON.stringify(Array.from(eval(value))),
      );
    } else {
      // eslint-disable-next-line
      const serialized = JSON.stringify(eval(value));
      if (serialized === undefined) return;
      sessionStorage.setItem(`${id}${key}`, serialized);
    }
  };

  const getSessionStorageData = (sessionID) => {
    if (!sessionID) {
      get();
      return;
    }
    ctx.setIsLoad(true);
    const tempO = parseSessionStorageItem(`${sessionID}operation`);
    const tempD = parseSessionStorageItem(`${sessionID}data`);
    const tempOS = parseSessionStorageItem(`${sessionID}open`);
    const tempPR = parseSessionStorageItem(`${sessionID}passedRow`);

    if (
      (tempO && tempO !== "") ||
      (tempD && Object.keys(tempD).length !== 0) ||
      tempOS ||
      (tempPR && Object.keys(tempD).length !== 0)
    ) {
      setOperation(new String(tempO));
      setData(new Object(tempD));
      setOpen(tempOS);
      setPassedRow(tempPR);
      ctx.setIsLoad(false);

      return;
    }
    get();
  };

  const fixResponseObject = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toLowerCase() + key.slice(1),
        value,
      ]),
    );

  const fixResponseListObject = (obj) =>
    obj.map((element) =>
      Object.fromEntries(
        Object.entries(element).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.slice(1),
          value,
        ]),
      ),
    );

  const get = () => {
    const row = ctx.passValue.get("Row")

    if (row) {
      const lines = ctx.passValue.get('Row')
      const tempId = lines.Id
      console.log("1", tempId)
      quoteGetRequestService.getId(tempId).then((response) => {
        if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("Error"),
            getApiErrorMessage(response),
          );
          ctx.setIsLoad(false);
          return;
        }
        console.log("ddddddd", response)

        const fixedQuoteResponse = fixResponseObject(response.Quote);
        const fixedGoodsResponse = hydrateGoodsFromQuoteDescription(
          fixResponseListObject(response.Goods),
          fixedQuoteResponse,
        );
        const fixedEquipmentResponse = fixResponseListObject(
          response.Equipment,
        );
        const fixedChargesResponse = response.Charges ? fixResponseListObject(response.Charges) : [];
        const fixedChargesResponseWithId = fixedChargesResponse.map((value, index) => ({ ...value, id: index }))

        delete fixedQuoteResponse.Goods;
        delete fixedQuoteResponse.Equipment;
        delete fixedQuoteResponse.Charges;

        const fixedQuoteResponseDates = {
          ...fixedQuoteResponse,
          startDate: fixedQuoteResponse.startDate?.split("T")[0],
          dueDate: fixedQuoteResponse.dueDate?.split("T")[0],
          expireDate: fixedQuoteResponse.expireDate?.split("T")[0],
        };

        const fixedEquipmentTypesResponse = fixedEquipmentResponse.map(
          (equipment) => ({
            ...equipment,
            equipmentType: `${equipment["equipmentTypeLenght"]}${equipment["equipmentTypeCode"]}`,
          }),
        );

        const fixedAllResponses = resolveCompanyState({
          ...fixedQuoteResponseDates,
          Goods: fixedGoodsResponse,
          Equipments: fixedEquipmentTypesResponse,
          charges: fixedChargesResponseWithId,
          isApprovePage: true,
          companyOptions: getCompanyOptionsFromSession(),
        });

        setData(fixedAllResponses);
        changes(
          "counterCharges",
          fixedAllResponses.charges.length,
          setData,
        );
        
        changes(
          "GoodsCounter",
          fixedAllResponses.Goods.length,
          setData,
        );

        ctx.setIsLoad(false);
      })
        .catch((err) => {
          ctx.toastMessages("error", err.message, "Error");
          ctx.setIsLoad(false);
        });
    } else {
      changes("counterCharges", 0, setData);
      if (ctx.passValue.get("Rows")?.length > 1) {
        setData({ ...data, isMultiEdit: true });
      }
    }

    changes("totalCurrency", "€", setData);

    getCompanies();
    ctx.setIsLoad(false);
  };

  const getCompanies = () => {
    let tempCompanies = JSON.parse(sessionStorage.getItem("companies"));
    if (tempCompanies.length === 0) {
      ctx.toastMessages("error", "User has no companies!", "");
    }
    if (tempCompanies.length === 1) {
      getAccount(tempCompanies[0]);
    }

    changes(
      "companyOptions",
      tempCompanies.map((field) => {
        return { label: field.Name, value: field.AccountId, ...field };
      }),
      setData,
    );
  };

  const getAccount = (companyOrAccountId) => {
    if (!companyOrAccountId) {
      changes("clientCode", "", setData);
      changes("clientName", "", setData);
      changes("clientVat", "", setData);
      changes("userCompanyId", "", setData);
      changes("clientId", "", setData);
      changes("accountId", "", setData);
      return;
    }
    const accountGuid =
      typeof companyOrAccountId === "object"
        ? companyOrAccountId.AccountId ?? companyOrAccountId.value
        : companyOrAccountId;
    const companyUserId =
      typeof companyOrAccountId === "object" && companyOrAccountId.Id
        ? companyOrAccountId.Id
        : null;

    if (companyUserId) {
      changes("userCompanyId", companyUserId, setData);
    }
    if (typeof companyOrAccountId === "object") {
      changes("accountId", accountGuid || "", setData);
    }
    accountService.getId(accountGuid).then((res) => {
      if (res.name === "AxiosError") {
        ctx.toastMessages("error", "Couldnt fetch Account!", "");
        return;
      }
      changes("clientCode", res.AccountCode, setData);
      changes("clientName", res.AccountName || "", setData);
      changes("clientVat", res.AccountVATNumber, setData);
      changes("clientId", res.Id || accountGuid, setData);
      if (res.UserCompanyId) {
        changes("userCompanyId", res.UserCompanyId, setData);
      }
    });
  };

  const getApiErrorMessage = (response) => {
    const payload = response?.response?.data;
    if (!payload) return response?.message || "";
    if (typeof payload === "string") return payload;

    const flattenMessages = (value) => {
      if (value == null) return [];
      if (typeof value === "string") return [value];
      if (Array.isArray(value)) return value.flatMap(flattenMessages);
      if (typeof value === "object") return Object.values(value).flatMap(flattenMessages);
      return [String(value)];
    };

    if (Array.isArray(payload)) {
      return flattenMessages(payload).join("\n");
    }

    if (payload?.Errors != null) {
      return flattenMessages(payload.Errors).join("\n");
    }

    if (payload?.errors != null) {
      return flattenMessages(payload.errors).join("\n");
    }

    if (payload?.message) return payload.message;
    if (payload?.detail) return payload.detail;
    if (payload?.title) return payload.title;

    const messages = flattenMessages(payload).filter((m) => String(m).trim() !== "");
    if (messages.length > 0) return messages.join("\n");

    return response?.message || "";
  };

  const onSave = async (status) => {
    const validationErrors = [];
    if (!data?.quoteCode) {
      validationErrors.push(`${t("QuoteCode")} ${t("IsRequired")}`);
    }
    if (!data?.name) {
      validationErrors.push(`${t("QuoteName")} ${t("IsRequired")}`);
    }
    if (!hasGoodsDescription(data)) {
      validationErrors.push(`${t("GoodsDescription")} ${t("IsRequired")}`);
    }
    if (validationErrors.length > 0) {
      ctx.toastMessages("error", t("ErrorUpdating"), validationErrors.join("\n"));
      return;
    }

    if (status === "A") {
      if (!hasValue(data?.remarks)) {
        ctx.toastMessages("error", t("ErrorUpdating"), `${t("Remarks")} ${t("IsRequired")}`);
        return;
      }

      if (!data.charges || data.charges.length === 0) {
        ctx.toastMessages("error", "", t("ChargesRequiredError"));
        return;
      }

      const chargeRequiredFields = [
        { key: "serviceCode", label: t("ServiceCode") },
        { key: "currencyCode", label: t("Currency") },
        { key: "salesValue", label: t("SalesValue") },
        { key: "multiple", label: t("Multiple") },
      ];

      for (let i = 0; i < data.charges.length; i++) {
        const charge = data.charges[i];
        const missing = chargeRequiredFields
          .filter((f) => !charge[f.key] && charge[f.key] !== 0)
          .map((f) => f.label);
        if (missing.length > 0) {
          ctx.toastMessages(
            "error",
            "",
            <span><b>{t("ChargesMissingFields")}</b>: {missing.join(", ")}</span>,
          );
          return;
        }
      }
    }

    const quoteCodeToCheck = (data?.quoteCode || "").trim();
    if (quoteCodeToCheck) {
      const escapedCode = quoteCodeToCheck.replaceAll("'", "''");
      const duplicateCodeResponse = await quoteService.filter(`?page=1&pagesize=500&filter=QuoteCode eq '${escapedCode}'`);
      if (duplicateCodeResponse?.name !== "AxiosError") {
        const duplicateCodeItems = Array.isArray(duplicateCodeResponse)
          ? duplicateCodeResponse
          : duplicateCodeResponse?.Items || [];
        const hasDuplicateCode = duplicateCodeItems.some((item) => item?.Id !== data?.id && (item?.QuoteCode || item?.quoteCode) === quoteCodeToCheck);
        if (hasDuplicateCode) {
          ctx.toastMessages("error", t("ErrorUpdating"), `${t("QuoteCode")} duplicado.`);
          return;
        }
      }
    }

    const tempCharges = data.charges?.map((obj) => {
      const { id, ...rest } = obj;
      return rest;
    });

    if (!data.Equipments) data.Equipments = [];

    const tempEquipments = normalizeQuoteEquipmentsForSave(data.Equipments || []);

    const tempGoods = normalizeQuoteGoodsForSave(data.Goods || []);

    const rows = ctx.passValue.get("Rows")

    const normalizedData = resolveCompanyState(data);
    const quotePayload = buildQuotePayload(normalizedData, {
      status,
      goodsDescription: resolveQuoteGoodsDescription(normalizedData),
    });
    if (!quotePayload.dueDate) {
      quotePayload.dueDate = quotePayload.expireDate || quotePayload.startDate || null;
    }

    const saveData = {
      Equipments: tempEquipments,
      Goods: tempGoods,
      Charges: tempCharges,
      Quote: quotePayload,
      IsMultiEdit: data.isMultiEdit,
      MultiEditQuoteIds: rows?.map((x) => x.Id),
      CreateRevision: false,
    };
    ctx.setIsLoad(true);
    quoteUpdateRequestService.update(data.id, saveData).then((response) => {
      if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("ErrorUpdating"),
            getApiErrorMessage(response),
          );
          ctx.setIsLoad(false);
      } else {
          ctx.toastMessages(
              "success",
              t("Success"),
              t("EditedQuote"),
          );
          ctx.setIsLoad(false);
          navigateCtx.closeTab(id.replace(/"/g, ''))
      }
  });
};

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("Refresh")}
              icon={<Refresh />}
              label={t("Refresh")}
              onClick={() => get()}
            />
            <M_Button
              tooltip={t("AcceptQuote")}
              icon={<img src='\icons\svgsDaNet\check-circle.svg' style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '20px' }} alt='AcceptQuote' />}
              label={t("AcceptQuote")}
              onClick={() => onSave("A")}
            />
            <M_Button
              tooltip={t("RejectQuote")}
              icon={<img src='\icons\svgsDaNet\x-circle.svg' style={{ filter: 'invert(8%) sepia(94%) saturate(6897%) hue-rotate(3deg) brightness(108%) contrast(110%)', width: '20px' }} alt='RejectQuote' />}
              label={t("Reject")}
              onClick={() => setShowRejectDialog(true)}
            />
          </>
        }
      />
      <div style={{ margin: "20px" }}>
        <QuoteInfoDatesPortsSection
          wide={matches11}
          quoteInfo={<QuoteInfo dataState={data} setDataState={setData} remarksRequired />}
          dates={<QuoteDates dataState={data} setDataState={setData} hideDueDate />}
          ports={<QuotePorts dataState={data} setDataState={setData} />}
        />
        <div>
          <QuoteEntities dataState={data} setDataState={setData} />
        </div>
        <QuoteEquipmentGoodsSection
          wide={matches12}
          equipment={<QuoteEquipment dataState={data} setDataState={setData} />}
          goods={<QuoteGoods dataState={data} setDataState={setData} />}
        />
        <QuoteCharges
          dataState={data}
          setDataState={setData}
          passedRowState={passedRow}
          setPassedRowState={setPassedRow}
          triggerAddNewCharge={triggerAddNewCharge}
        />
        <div style={{ margin: "25px" }}></div>
        <QuoteCalculator dataState={data} setDataState={setData} />
      </div>
      <M_MessageBoard
        open={showRejectDialog}
        onClose={() => setShowRejectDialog(false)}
        title={t("LabelRejectBooking")}
        body={
          <>
            <QuoteFormField
              fields={{
                display: t("Reason"),
                code: "rejectReason",
                type: "textArea",
                required: true,
              }}
              data={data}
              setData={setData}
              size={400}
            />
            {/* <M_TextArea
              label={t("Notes")}
              value={finalNotes}
              onChange={(e) => setFinalNotes(e.target.value)}
            /> */}
          </>
        }

        footer={
          <div style={{ display: 'flex' }}>
            <M_Button
              normal
              hoverEffect
              label={t("ButtonCancel")}
              backgroundColor={'var(--color-red)'}
              labelColor={'var(--color-white)'}
              onClick={() => setShowRejectDialog(false)}
            />
            <M_Button
              normal
              hoverEffect
              label={t("ConfirmReject")}
              backgroundColor={'var(--color-green)'}
              labelColor={'var(--color-white)'}
              onClick={() => onSave("X")}
            />
          </div>
        }
    />
      {/* <M_MessageBoard
        warning
        open={showRejectDialog}
        onClose={() => setShowRejectDialog(false)}
        title={t("RejectQuote")}
        body={
          <QuoteFormField
            fields={{
              display: t("Reason"),
              code: "rejectReason",
              type: "text",
              required: true,
            }}
            data={data}
            setData={setData}
          />
        }
        footer={
          <div style={{ display: 'flex' }}>
            <M_Button
                normal
                hoverEffect
                label={t("ButtonCancel")}
                backgroundColor={'var(--color-red)'}
                labelColor={'var(--color-white)'}
                onClick={() => setShowRejectDialog(false)}
            />
            <M_Button
                normal
                hoverEffect
                label={t("Delete")}
                backgroundColor={'var(--color-green)'}
                labelColor={'var(--color-white)'}
                onClick={() => onSave("X")}
            />
          </div>
        }
    /> */}
    </div>
  );
};
